import { useContext } from 'react';
import { WebThemeContext } from '../contexts/WebThemeContext';

export const useWebTheme = () => {
  const context = useContext(WebThemeContext);
  if (context === undefined) {
    throw new Error('useWebTheme must be used within a WebThemeProvider');
  }
  return context;
};

